var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cata-item"},[(_vm.cata.children)?_c('div',{staticClass:"cata-body folder",class:{
      active: _vm.containActive,
    },style:({
      paddingLeft: _vm.padding + 'px',
    }),on:{"click":function($event){_vm.unfold = !_vm.unfold}}},[_c('img',{staticClass:"arrow",style:({
        transform: _vm.unfold ? 'rotate(90deg)' : '',
      }),attrs:{"src":require("@/assets/icon/arrow.png"),"alt":""}}),_c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.cata.name))])]):_c('div',{staticClass:"cata-body article",class:{
      active: _vm.catalog.activeCata === this.cata,
    },style:({
      paddingLeft: _vm.padding + 'px',
    }),on:{"click":_vm.articleClick}},[_c('div',{staticClass:"article-name"},[_c('div',{staticClass:"article-text"},[_vm._v(_vm._s(_vm.cata.name))])])]),(_vm.cata.children && _vm.unfold)?_vm._l((_vm.cata.children),function(item,index){return _c('cata-item',{key:index,attrs:{"cata":item,"padding":_vm.padding + 20}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }